import { getMonthlyRevenueByPeriod, getMonthlyRevenues } from "./asyncThunks";

export const getMonthlyRevenueByPeriodBuilder = (builder) => {
  builder.addCase(getMonthlyRevenueByPeriod.pending, (state) => {
    state.monthlyRevenueByPeriod.loading = true;
    state.monthlyRevenueByPeriod.error = null;
  });
  builder.addCase(getMonthlyRevenueByPeriod.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.monthlyRevenueByPeriod.data = data;
    state.monthlyRevenueByPeriod.loading = false;
  });
  builder.addCase(getMonthlyRevenueByPeriod.rejected, (state, action) => {
    state.monthlyRevenueByPeriod.loading = false;
    state.monthlyRevenueByPeriod.error = action.error.message;
  });
};

export const getMonthlyRevenuesBuilder = (builder) => {
  builder.addCase(getMonthlyRevenues.pending, (state) => {
    state.monthlyRevenue.loading = true;
    state.monthlyRevenue.error = null;
  });
  builder.addCase(getMonthlyRevenues.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.monthlyRevenue.data = data;
    state.monthlyRevenue.loading = false;
  });
  builder.addCase(getMonthlyRevenues.rejected, (state, action) => {
    state.monthlyRevenue.loading = false;
    state.monthlyRevenue.error = action.error.message;
  });
};
